module.exports = __webpack_public_path__ + "static/media/NUS_Future-ready_Graduates.f25f0e7a.png";